import React from "react";
import { TTranslateFunc } from "../../types/global";
import Flex from "../Flex";
import { IStep, Step } from "./Step";
import { TSize, TStepperDirection } from "./common";

type TProps = {
    currentStepIndex: number;
    steps: IStep[];
    size: TSize;
    direction?: TStepperDirection;
    translate: TTranslateFunc;
    alignText?: "left" | "center";
};

const getStatus = (stepIndex: number, activeIndex: number) => {
    if (stepIndex > activeIndex) {
        return "incomplete";
    }

    if (stepIndex < activeIndex) {
        return "complete";
    }

    return "current";
};

export const Stepper = ({
    currentStepIndex,
    steps,
    size,
    direction = "row",
    translate,
    alignText = "center"
}: TProps) => {
    return (
        <Flex direction={direction}>
            {steps.map((step, index) => (
                <Step
                    translate={translate}
                    key={step.title}
                    description={step.description}
                    first={index === 0}
                    last={index === steps.length - 1}
                    direction={direction}
                    size={size}
                    status={getStatus(index, currentStepIndex)}
                    title={step.title}
                    alignText={alignText}
                />
            ))}
        </Flex>
    );
};
